import { facebook } from '@itau-loans-www/utils'

import auth from './auth'
import { defaultLeadsApiCall } from './utils'

const postSimulationData = async (requestBody, isPartner) => {
  const response = await auth({}).then((_http) =>
    _http.post(
      `v2/itau-loans-api/fgts/simulation/?partner=${isPartner}`,
      requestBody
    )
  )

  return response
}

const putZipCodeData = async (requestBody) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'zipcode-data',
    method: 'put',
    body: requestBody
  })

  return data
}

const putSellerData = async (requestBody) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'assistant',
    method: 'put',
    body: requestBody
  })

  return data
}

const getSellerData = async () => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'assistant',
    method: 'get'
  })

  return data
}

const getFgtsAllowed = async () => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'fgts-allowed',
    method: 'get'
  })

  return data
}

const putFgtsAllowed = async (requestBody = {}) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'fgts-allowed',
    method: 'put',
    body: requestBody
  })

  if (data?.is_final_step) {
    facebook.trackLeadComplete('FGTS')
  }

  return data
}

export default {
  getFgtsAllowed,
  putFgtsAllowed,
  postSimulationData,
  putZipCodeData,
  putSellerData,
  getSellerData
}
